export const SKILL_FORM_MAX_WIDTH = 612;
